import { ReactNode, useState } from "react";
import { useRecoilState } from "recoil";
import { Button, Stepper } from "src/components";

import { HasBooking, NoNextBooking, WaitEventBookingProposal } from "src/components/EventBooking";
import MainNavBtns from "src/components/MainNavBtns";
import { useUserStepStatusEvent } from "src/hooks";
import { recoilStates } from "src/recoil/recoilStates";
import { colors } from "src/styles/theme";
import { NavMenuNames, userStepStatusEvent, MainNavChildObjectType } from "src/types";
import styled, { css } from "styled-components";
import { IoMdPersonAdd } from "react-icons/io";
import { FaHandshake } from "react-icons/fa";
import { FaCoins } from "react-icons/fa";
import faq from "../assets/images/help.svg";
import list from "../assets/images/list_alt.svg";

import HasProposal from "../components/EventBooking/HasProposal";

const mainComponentObj: { [key in userStepStatusEvent]: ReactNode } = {
  // noNextEvent: <NoYearGroupContent />,
  noBooking: <NoNextBooking />,
  waitingProposal: <WaitEventBookingProposal />,
  hasProposal: <HasProposal />,
  // noBooking: <NoBookingContent isRejectedByAllClubs={false} />,
  // waitingProposal: <WaitYearBookingProposal />,
  rejectedAllProposal: <NoNextBooking isRejectedByAllClubs={true} />,
  hasBooking: <HasBooking />,
  // hasProposal: <HasProposal />,
  // waitingDeposit: <PaymentWating />,
  // completeDeposit: <HasYearBookingContent />,
};

function closeB() {
  const win: any = window;
  const handler = win?.webkit?.messageHandlers?.cordova_iab;
  if (handler) {
    try {
      handler.postMessage(JSON.stringify({ type: "exit" }));
    } catch (e) {
      alert(e);
    }
  } else {
    alert("no handler");
  }
}

export default function EventBooking() {
  const [init] = useRecoilState(recoilStates.init);
  const [user] = useRecoilState(recoilStates.user);
  const [eventApplication] = useRecoilState(recoilStates.eventApplication);

  // 검토 중인 클럽 수 계산 (status_id가 1인 경우)
  const reviewingClubs =
    eventApplication?.event_booking_rel_club?.filter((clubRel) => clubRel.status_id === 1) || [];

  const userStep = useUserStepStatusEvent();
  const temp = 159723;
  const [open, setOpen] = useState(true);
  if (!open) {
    return (
      <div className="d-flex flex-1 fd-c">
        <div className="flex-1 d-flex fd-c jc-c ai-c gap-3">
          <div>준비중입니다.</div>
          <Button
            $colorTheme="green"
            $buttonSize="md"
            className="pd-5"
            $round
            onClick={() => closeB()}
          >
            돌아가기
          </Button>
        </div>
        <div
          onClick={() => {
            const zz: any = window.prompt("qwer");
            if (zz === String(temp)) {
              setOpen(true);
            }
          }}
        >
          _
        </div>
      </div>
    );
  }

  return (
    <Main className="flex-1 d-flex" $isUserDateFetchDone={init.isInit}>
      {init.isInit ? (
        <>
          {userStep ? (
            <>
              <Stepper
                className="page-pd-negative-side page-pd-negative-top"
                currentIdx={0}
                stepsXpadding="50px"
                title={
                  userStep === "noBooking"
                    ? "월 단체 예약을 신청해보세요."
                    : userStep === "waitingProposal"
                    ? `${reviewingClubs.length}개 골프장에서 조건 검토중입니다.`
                    : userStep === "hasProposal"
                    ? "조건 검토 후 확정하세요~"
                    : "월 단체 예약을 신청해보세요."
                }
                steps={[
                  { label: "예약 신청", icon: "booking-register" },
                  { label: "조건 협의", icon: "select-club" },
                  { label: "예약 확정", icon: "confirm-club" },
                ]}
              />
              <MainNavBtns
                showingChildNames={userStatusToMenusObj[userStep]}
                childDataObject={childDataObject}
              />
              {mainComponentObj[userStep]}
            </>
          ) : null}
        </>
      ) : (
        <></>
      )}
    </Main>
  );
}

const childDataObject: MainNavChildObjectType = {
  faq: {
    img: faq,
    name: "자주묻는질문",
    size: 4,
    isNav: true,
    navPath: "/event-booking/faq",
  },

  member: {
    icon: <IoMdPersonAdd size={"22"} />,
    name: "멤버관리",
    isNav: true,
    navPath: "/event-booking/member-list",
  },

  bookingRegisterResult: {
    img: list,
    name: "신청내역",
    isNav: true,
    navPath: "/event-booking/register-result",
  },
  bookingProposalResult: {
    icon: <FaHandshake size={"22"} />,
    name: "협약내용",
    isNav: true,
    // navPath: "/year-booking?bookingCondition=1",
    navPath: "/event-booking/condition",
  },
  roundPayment: {
    icon: <FaCoins size={"22"} />,
    name: "수수료&보증금",
    size: 3,
    isNav: true,
    // navPath: "/year-booking?bookingCondition=1",
    navPath: "/event-booking/payment",
  },
};

const userStatusToMenusObj: Partial<{ [key in userStepStatusEvent]: NavMenuNames[] }> = {
  noBooking: ["faq"],
  rejectedAllProposal: ["faq"],
  waitingProposal: ["faq", "bookingRegisterResult"],
  hasProposal: ["faq", "bookingRegisterResult"],
  hasBooking: ["roundPayment", "faq", "member", "bookingProposalResult"],
  // noBooking: ["faq", "group", "member"],
  // rejectedAllProposal: ["faq", "group", "member"],
  // waitingProposal: ["faq", "group", "member", "bookingRegisterResult"],
  // hasProposal: ["faq", "group", "member", "bookingRegisterResult"],
  // waitingDeposit: ["faq", "group", "member", "bookingProposalResult", "deposit"],
  // completeDeposit: ["roundPayment", "faq", "group", "member", "bookingProposalResult"],
};

const Main = styled.main<{ $isUserDateFetchDone: boolean }>`
  display: flex;
  flex-direction: column;
  ${(p) =>
    !p.$isUserDateFetchDone &&
    css`
      align-items: center;
      justify-content: center;
    `}

  .group-top {
    /* padding: 0px 10px; */
    background-color: ${colors.gray.fourth};
    margin-top: -15px;
    margin-left: -15px;
    margin-right: -15px;

    .img-box,
    img {
      width: 50px;
      height: 50px;
      border-radius: 999px;
    }
    img {
      object-fit: cover;
    }

    .group-img {
    }
  }
`;
